export const environment = {
  production: false,
  apiUrl: '',
  webconfigUrl: 'https://somewherefine.com',
  paymentUrlPayu: 'https://test.payu.in/_payment',
};
